import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const userEnrichmentSchema = z.object({
  userId: z.string(),
  score: z.number(),
  currentStreak: z.number(),
  lastActiveDate: z.string().nullable(),
  totalActiveDays: z.number(),
  totalPassed: z.number().nullish(),
  subscriptionPlan: z.string().nullable(),
  subscriptionStatus: z.string().nullable(),
  latestDevicePlatform: z.string().nullable(),
  latestDeviceModel: z.string().nullable(),
  latestDeviceOs: z.string().nullable(),
  signupDevicePlatform: z.string().nullish(),
});

const usersEnrichmentDataSchema = z.array(userEnrichmentSchema);

export type IUserEnrichment = z.infer<typeof userEnrichmentSchema>;

export const getUsersEnrichmentResponseSchema = createApiResponseSchema(
  usersEnrichmentDataSchema,
) as z.ZodSchema<IAPI<IUserEnrichment[]>>;

export type IGetUsersEnrichmentResponse = IAPI<IUserEnrichment[]>;
